import { type HandleProps, type NodeProps } from '@xyflow/react';
import { ConditionTypes } from 'automations/types/automationConfig';
import { type ConditionNodeType } from 'automations/types/nodeTypes';

import useCompare from './useCompare';
import useElse from './useElse';
import useIf from './useIf';
import useIfElse from './useIfElse';
import useMultiIfElse from './useMultiIfElse';
import useWait from './useWait';

export interface ConditionNodeReturnProps {
  subTitle?: React.ReactNode;
  icon: React.FC<any>;
  dangerIcon?: boolean;
  hasErrors: boolean;
  errorMessages: string[];
  handleEdit?: () => void;
  handleCopy?: () => void;
  AdditionalUI?: React.ReactNode;
  targetHandle?: Partial<HandleProps>;
  canOpenMenu?: boolean;
  canDelete?: boolean;
}

export const ConditionNodeConfigFactory = {
  [ConditionTypes.ifElse]: useIfElse,
  [ConditionTypes.wait]: useWait,
  [ConditionTypes.compare]: useCompare,
  [ConditionTypes.multiIfElse]: useMultiIfElse,
  [ConditionTypes.if]: useIf,
  [ConditionTypes.else]: useElse,
};

export default function useConditionNodeConfig(node: NodeProps<ConditionNodeType>): ConditionNodeReturnProps {
  const { data: { nodeSubType } } = node;

  return ConditionNodeConfigFactory[nodeSubType](node as any);
}
